import { Injectable, signal, computed } from '@angular/core';

export const STAGE_NAMES = [
  'Lead dashboard',
  'AI call · live',
  'Need analysis',
  'Plan recommendation',
  'Quotation',
  'Paperless KYC',
  'Proposal & e-sign',
  'Payment',
  'Certificate issued',
];

export const TOTAL_STAGES = 9;

/**
 * Shared walkthrough state for the 9-stage Journey. Holds which prospect we're
 * following and the ids produced as the prospect moves through the journey so
 * each stage can chain onto the previous one.
 */
@Injectable({ providedIn: 'root' })
export class JourneyStateService {
  // Default target prospect = Priya Sharma (the live walkthrough subject).
  readonly prospectId = signal<string>('PROS-2026-04719');
  // Selected lead's display name — shown across every Journey tab (incl. the
  // static Quotation/Proposal/Payment/Certificate tabs). Updated whenever the
  // prospect is loaded (AppComponent), so picking a lead updates it everywhere.
  readonly customerName = signal<string>('Priya Sharma');

  readonly current = signal<number>(1);

  // Cross-stage artefacts.
  readonly callId = signal<string | null>(null);
  readonly needId = signal<string | null>(null);
  readonly selectedUin = signal<string | null>(null);
  readonly quoteId = signal<string | null>(null);
  readonly kycId = signal<string | null>(null);
  readonly proposalId = signal<string | null>(null);
  readonly paymentId = signal<string | null>(null);
  readonly policyNumber = signal<string | null>(null);

  readonly progressPct = computed(() => (this.current() / TOTAL_STAGES) * 100);

  setProspect(id: string) {
    this.prospectId.set(id);
    // Reset artefacts when switching prospect.
    this.callId.set(null);
    this.needId.set(null);
    this.selectedUin.set(null);
    this.quoteId.set(null);
    this.kycId.set(null);
    this.proposalId.set(null);
    this.paymentId.set(null);
    this.policyNumber.set(null);
  }

  go(stage: number) {
    if (stage >= 1 && stage <= TOTAL_STAGES) this.current.set(stage);
  }
  next() { this.go(this.current() + 1); }
  prev() { this.go(this.current() - 1); }
  reset() { this.current.set(1); }
}
